import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ListaResultset } from 'src/app/core/list/lista-resultset.interface';
import { IAlertaCard } from './alerta-card/alerta-card.interface';
import { IAlertaFilter } from './model/alerta.filter';
import { IAlerta } from './model/alerta.interface';
import { Alerta } from './model/alerta.model';


export abstract class AlertaServiceAbstract extends DefaultService<Alerta> {

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService,
    private _url: string
  ) { 
    super(
      httpClient,
      errorHandler,
      _url
    );
  }

  public abstract criarAlerta(alerta: IAlerta): Observable<any[]>;

  public abstract removerAlerta(idAlerta: number): Observable<boolean>;

  public abstract getGatilhos(): string[];

  public abstract buscarAlertaCardDTO(idAlerta: number): Observable<IAlertaCard[]>;

  public abstract listarAlertaCardDTO(alertaFilter: IAlertaFilter): Observable<ListaResultset<IAlertaCard>>;

}
